module.exports = __webpack_public_path__ + "img/news_1.d00d60ce.png";